/* wsapi3-condition v1.0 */
/* Deploy Version 2026-09-29 09:00:57 */
/* Deploy Version 2026-09-24 19:11:10 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: 'condicoes',
  version: '1.0',
  updatedAt: '2026-07-14',
  function: 'get',
  onlyAfter: 'info-lojas',
  options: {
    templateConfigs: {
      icon: true,
      title: true,
      subtitle: true
    }
},
  get() {
    let tag = document.querySelectorAll('[data-wsjs-module="condition"]');
    if (!tag || tag.length == 0) return true;

    tag.forEach(t => {
      if (t.hasAttribute('data-ws-rendered')) wsMain.modules['condicoes'].reuse(t);
      else wsMain.modules['condicoes'].create(t);
    });

    return true;
  },
  reuse(elm) {
    // Só roda de fato quando a âncora tem slide (mobile) E tem só 1 condição (o caso raro em
    // que o servidor renderiza tudo mesmo com slide configurado) — o caso comum (mais de 1
    // condição + slide) usa um preview de 1 item sem data-ws-rendered, então cai em create(),
    // não aqui (ver conditions-server-render.service.ts).
    let slideOptions = wsMain.tools.getWsData(elm, 'slide');
    if (slideOptions) {
      let holder = elm.querySelector(':scope > .condicoes-loja');
      if (holder) {
        // createSlide() pega TODOS os filhos do holder, inclusive os que o servidor
        // escondeu com display:none pro "frame inicial" — o KeenSlider tenta medir
        // esses itens invisíveis (largura 0) e a conta de tamanho "explode". Remove o
        // display:none antes: o KeenSlider passa a controlar quem fica visível de verdade.
        Array.from(holder.children).forEach(child => { if (child.style.display === 'none') child.style.display = ''; });
        // Força o navegador a recalcular o layout AGORA (reflow síncrono) — sem isso o
        // KeenSlider mede o container antes do reflow do display:none acima ter sido
        // processado, e calcula um tamanho de slide absurdo em cima de uma medida velha.
        void holder.offsetHeight;
        let [slideSuccess, slide] = wsMain.tools.createSlide(holder, slideOptions);
        if (slideSuccess && slide) {
          slide.update();
          // Segunda rede de segurança (mesmo padrão do wsapi3-banners.js): reconfere o
          // tamanho depois que o browser realmente pintou o frame.
          setTimeout(() => slide.update(), 50);
        }
      }
    }
    // Seções da home (data-wsjs-container) só ficam visíveis quando dataLoad() sobe a
    // árvore removendo esse atributo — normalmente acontece dentro de replaceSpanTag(),
    // que a gente pulou de propósito aqui.
    wsMain.addons.dataLoad(elm);
  },
  create(elm) {
    let templateConfigs = JSON.parse(JSON.stringify(wsMain.options['condicoes'].templateConfigs));
    let condicoes = wsMain.globalData['infoLoja'].condicoes;

    let optionsCondition = wsMain.tools.getWsData(elm, 'options');
        templateConfigs = {...templateConfigs, ...optionsCondition};

    if (!Array.isArray(condicoes) || condicoes.length == 0) return true;

    let conditionContainer = wsMain.tools.createElm({
        type: 'div', 
        attrs: {
            class: 'condicoes-loja',
        }
    });

    condicoes.forEach((c, i)=> {
        let 
            itemContainer = wsMain.tools.createElm({type: 'div', attrs: {class: 'condicao-item condicao-item-' + i}}),
            iconContainer = wsMain.tools.createElm({type: 'div', innerHTML: c.icone, attrs: {class: 'condicao-icone'}}),
            textContainer = wsMain.tools.createElm({type: 'div', attrs: {class: 'condicao-textos'}}),
            title = wsMain.tools.createElm({type: 'h3', innerHTML: c.titulo, attrs: {class: 'condicao-titulo'}}),
            subtitle = wsMain.tools.createElm({type: 'p', innerHTML: c.subtitulo, attrs: {class: 'condicao-subtitulo'}});

        if (templateConfigs.title) textContainer.append(title);
        if (templateConfigs.subtitle) textContainer.append(subtitle);
        
        let conditionHiperLink = wsMain.tools.createElm({
            type: c.url ? 'a' : 'div', 
            attrs: { 
              class: 'condicao-hiperlink'
            }
        });

        if (c.url) {
          conditionHiperLink.setAttribute('href', c.url);
        }

        if (templateConfigs.icon) conditionHiperLink.append(iconContainer);
        if (templateConfigs.title || templateConfigs.subtitle) conditionHiperLink.append(textContainer);
        
        itemContainer.append(conditionHiperLink);
        conditionContainer.append(itemContainer);
    });

    let conditionSlideOptions = wsMain.tools.getWsData(elm, 'slide');

    // Anexa ANTES de montar o slide (era o contrário) — createSlide() mede a largura do
    // container pra calcular o tamanho de cada item, e um elemento ainda fora do documento
    // sempre mede 0. Isso fazia a seção alternar entre altura 0 e a altura real logo depois de
    // inserida, empurrando (e trazendo de volta) tudo que vem abaixo na página — mesma causa
    // por trás do salto de CLS que via em condições mesmo sem nenhum problema visível nela.
    if (templateConfigs.icon || templateConfigs.title || templateConfigs.subtitle) wsMain.tools.replaceSpanTag(conditionContainer, elm);

    let [slideSuccess, slide] = conditionSlideOptions ? wsMain.tools.createSlide(conditionContainer, conditionSlideOptions) : [null, null];

    if (slideSuccess) slide.update();

    return true;
  }
});
